import { axiosClient } from "@lib/services/axios";
import { ENDPOINTS } from "@lib/constants/general";
import { UsersList } from "@lib/types/users";

export const getUsers = async (): Promise<UsersList> => {
  const { data } = await axiosClient.get(ENDPOINTS.BASE_ADMIN_USERS);
  return data;
};

export const getUnusedSlots = async (): Promise<string[]> => {
  const { data } = await axiosClient.get(
    `${ENDPOINTS.BASE_DRIVER}/unused-slots`
  );

  return data.map(String);
};
